import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NavItemType } from '../nav-items/models/nav-item-type.enum';
import { NavItemModel } from '../nav-items/models/nav-item.model';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthStorage } from '../../client/repositories/lib/auth';

@Component({
  selector: 'app-profile-menu-switch',
  templateUrl: './profile-menu-switch.component.html',
})
export class ProfileMenuSwitchComponent implements OnInit {
  // isSignedIn: boolean;
  @Output() emitSignOut = new EventEmitter<void>();

  signOutItem = {
    name: 'header.signOut',
    type: NavItemType.Button,
    class: 'btn btn-danger',
    onClick: () => {
      this.signOut();
    },
  } as NavItemModel;

  navItems: NavItemModel[] = [this.signOutItem];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authStorage: AuthStorage
  ) {}

  signOut(): void {
    // this.isSignedIn = false;
    this.emitSignOut.emit();
    // this.authStorage.clear();
    // this.router.navigate(['/']);
  }

  navigateToPasswordChange(): void {
    this.router.navigate(['/auth/set-new-password']);
  }

  navigateToAddressChangeRequest(): void {
    this.router.navigate(['/auth/request-address-change']);
  }

  ngOnInit(): void {}
}
